module.exports = __webpack_public_path__ + "media/images/pic/anime/singers-c518d32120dff1b11f5136415a7a05b4.svg";